import { ClassName, Col } from '@busybusy/webapp-react-ui';
import FlexContainer from '@busybusy/webapp-react-ui/dist/components/FlexContainer/FlexContainer';
import classNames from 'classnames';
import { Panel } from 'components';
import { ReactNode } from 'react';

export interface IManageListTableContainerProps {
  children: ReactNode;
  className?: ClassName;
}

export default function ManageListTableContainer({ children, className }: IManageListTableContainerProps) {
  const classes = classNames('manage-list-table-container', 'full-width', 'report-background-color', className);

  return (
    <Panel className={classes}>
      <FlexContainer justifyContent="center">
        <Col size={6}>{children}</Col>
      </FlexContainer>
    </Panel>
  );
}
